import moment from 'moment'
import 'moment/locale/tr'
import 'moment/locale/bg'
import {MStore} from "../networking/stores/MainStore";

export function l_moment(date,format) {
  moment.locale(MStore.language.locale)
  return moment(date,format)
}
